import React from 'react';

type FeaturedIconProps = React.SVGProps<SVGSVGElement>;

export const FeaturedIcon: React.FC<FeaturedIconProps> = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <g clipPath="url(#clip0_443_950)">
      <path
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
        fill="#F15E5F"
      />
      <path
        d="M5.9998 3.13037L6.64733 5.12324H8.74273L7.0475 6.35488L7.69503 8.34777L5.9998 7.1161L4.30456 8.34777L4.95209 6.35488L3.25684 5.12324H5.35226L5.9998 3.13037Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_443_950">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

FeaturedIcon.displayName = 'FeaturedIcon';

export default FeaturedIcon;
